import React, { useEffect } from 'react';
import { ProgressBarLoader } from '../components/ProgressBarLoader/ProgressBarLoader';
import { createPortal } from 'react-dom';
import { usePanorama } from '../context/PanoramaContext';
import { useInstallerContext } from '../context/InstallerContext';
import { CenteredSpinningLoader } from '../components/LoadingModal/CenteredSpinningLoader';
import { getNewWindowFeatures } from '../utils/getNewWindowFeatures';
export const useCreateNewWindowHandlersForContext = () => {
  const {
    errorMonitor
  } = usePanorama();
  const {
    avoidPostInstallation,
    preInstallationData: {
      isAdvancedOauthApp
    }
  } = useInstallerContext();
  const windowReference = React.useRef(null);
  const reactPortal = React.useRef(null);
  const broadcastChannel = React.useRef(new BroadcastChannel('oauth_installer_bc'));
  useEffect(() => {
    const bc = broadcastChannel.current;
    return () => {
      bc.close();
    };
  }, []);
  const embedComponentInNewWindow = Component => {
    try {
      if (windowReference != null && windowReference.current) {
        reactPortal.current = /*#__PURE__*/createPortal(Component, windowReference.current.document.body);
      }
    } catch (e) {
      var _errorMonitor;
      (_errorMonitor = errorMonitor()) == null || _errorMonitor.reportError(e);
    }
  };
  return {
    broadcastChannel: broadcastChannel.current,
    openNewWindow: () => {
      const windowFeatures = getNewWindowFeatures({
        avoidPostInstallation,
        isAdvancedOauthApp
      });
      windowReference.current = window.open('', '_blank', windowFeatures);
    },
    showProgressBar: () => {
      embedComponentInNewWindow(/*#__PURE__*/React.createElement(ProgressBarLoader, null));
    },
    showSpinningLoader: () => {
      embedComponentInNewWindow(/*#__PURE__*/React.createElement(CenteredSpinningLoader, null));
    },
    closeNewWindow: () => {
      if (windowReference.current) {
        windowReference.current.close();
      }
    },
    navigateToSecondRedirectUrlInOauth: url => {
      broadcastChannel.current.postMessage({
        type: 'navigateToRedirectUrl',
        redirectUrl: url
      });
    },
    updateWindowSrcWithUrl: url => {
      if (windowReference.current) {
        windowReference.current.location.href = url;
      }
    },
    navigateToPostInstallationUrlInOauth: url => {
      // navigate to post installation happens only in advanced oauth apps when they reach the second redirect.
      // has to be window post message because installer v1 is with generic subdomain and doesn't have a token
      if (windowReference.current) {
        windowReference.current.postMessage({
          type: 'navigatePostInstallation',
          url
        }, '*');
      }
    },
    avoidPostInstallationPostMessageInOauth: () => {
      if (windowReference.current) {
        windowReference.current.postMessage({
          type: 'avoidPostInstallation'
        }, '*');
      }
    },
    NewWindowPortal: reactPortal.current
  };
};
export const initNewWindowHandlers = {
  broadcastChannel: {},
  openNewWindow: () => {},
  closeNewWindow: () => {},
  updateWindowSrcWithUrl: () => {},
  navigateToSecondRedirectUrlInOauth: () => {},
  navigateToPostInstallationUrlInOauth: () => {},
  avoidPostInstallationPostMessageInOauth: () => {},
  showProgressBar: () => {},
  showSpinningLoader: () => {},
  NewWindowPortal: null
};
//# sourceMappingURL=useCreateNewWindowHandlersForContext.js.map